import angular from 'angular';
import { JsonSchemaStore } from './JsonSchemaStore';
export const agentStoreModule = angular
    .module('agentStore', [])
    .factory('createSchemaStore', () => (initial) => new JsonSchemaStore(initial))
    .name;
